import React, { Component } from 'react';
import { Col, Button, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import { firebase, firebaseDb, fbManufacturers, fbLooper, fbProducts } from '../../firebase';
import { withRouter } from 'react-router-dom';
import SimpleModal from '../widgets/modals/simplemodal';
import Uploader from '../widgets/uploader';

class AddRobot extends Component {

    state = {
        formFields:{
            robot_name:{
                value:'',
                required:true,
                error_msg:'Enter a Name Please'
            },
            robot_model:{
                value:'',
                required:true,
                error_msg:'Enter the Model Please'
            },
            robot_price:{
                value:'',
                required:true,
                error_msg:'Enter the Price'
            },
            robot_manu_id:{
                value:'',
                required:true,
                error_msg:'Select Manufacturer ID'
            },
            robot_details:{
                value:'',
                required:false,
                error_msg:''
            }
        },
        manufacturers:[],
        image_name:'',
        simpleModal:false,
        error_msg:null,
        pageLoading:false,
        fileURL:null       
    }

    setImageFileName = (filename) => {
        this.setState({
            image_name:filename
        });
        firebase.storage()
        .ref('roboImages')
        .child(filename).getDownloadURL().then((url)=>{
            this.setState({fileURL:url});
        });
    }

    componentWillMount = () => {
        if(this.props.robot_id){
            this.setState({
                pageLoading: true
            });
        }
    }

    componentDidMount = () => {
        fbManufacturers.once('value').then((snap)=>{
            let manufacturers = fbLooper(snap);
            this.setState({
                manufacturers
            });
        });

        if(this.props.robot_id){
            firebaseDb.ref(`products/${this.props.robot_id}`).once('value').then((snap)=>{
                let product = snap.val();
                let newFields = {...this.state.formFields};
                newFields.robot_name.value = product.name;
                newFields.robot_price.value = product.price;
                newFields.robot_model.value = product.model;
                newFields.robot_details.value = product.details;
                newFields.robot_manu_id.value = product.manufacturer_id;
                this.setState({
                    formFields:newFields,
                    pageLoading:false
                });
                this.setImageFileName(product.image);
            });
        }
    }

    getManufacturers = () => {
        let template = null;
        if(this.state.manufacturers.length>0){
            template = this.state.manufacturers.map((item , i)=>(
                <option key={i} value={item.id}>{item.name}</option>
            ));
        }
        return template;
    }

    onFieldChange = (event, elementName) => {
        let newElm = {...this.state.formFields};
        newElm[elementName].value=event.target.value;
        this.setState({
            formFields:newElm
        });
    }

    isEveryFieldOk = () => {
        let {formFields} = this.state;
        for(let key in formFields){
            if(formFields[key].required===true){
                if(formFields[key].value===''){
                    this.setState({
                        error_msg: formFields[key].error_msg
                    });
                    return false;
                }
            }
        }
        if(this.state.image_name===''){
            this.setState({
                error_msg: "Upload a Photo Please..."
            });
            return false;
        }
        return true;
    }


    render() {
        if(this.state.pageLoading){
            return (
                <div>
                    <h3>Loading...</h3>
                </div>
            );
        }
        return (
            <div>
                {
                    this.state.simpleModal ?
                        <SimpleModal
                            showOnLoad={true}
                            title="It was successful"
                            okBtn="Ok"
                            okBtnClicked={()=>{
                                this.props.history.push({
                                    pathname: "/dashboard"
                                });
                            }}
                            details="It was success full. Click Ok To go to the dashboard page."
                        />
                    : null
                }
                <Form onSubmit={(e)=>{
                                e.preventDefault();
                                if(this.isEveryFieldOk()){
                                    if(this.props.robot_id){
                                        firebaseDb.ref(`products/${this.props.robot_id}`).update({
                                            name: this.state.formFields.robot_name.value,
                                            model: this.state.formFields.robot_model.value,
                                            add_time: firebase.database.ServerValue.TIMESTAMP,
                                            details: this.state.formFields.robot_details.value,
                                            price: this.state.formFields.robot_price.value,
                                            manufacturer_id: this.state.formFields.robot_manu_id.value,
                                            image: this.state.image_name
                                        }).then((product)=>{
                                            this.setState({
                                                simpleModal: true
                                            });
                                        });
                                    }else{
                                        fbProducts.push({
                                            name: this.state.formFields.robot_name.value,
                                            model: this.state.formFields.robot_model.value,
                                            add_time: firebase.database.ServerValue.TIMESTAMP,
                                            details: this.state.formFields.robot_details.value,
                                            price: this.state.formFields.robot_price.value,
                                            manufacturer_id: this.state.formFields.robot_manu_id.value,
                                            image: this.state.image_name
                                        }).then((product)=>{
                                            this.setState({
                                                simpleModal: true
                                            });
                                        });
                                    }
                                }
                            }}
                >
                    <FormGroup row>
                        <Col sm="4">
                            <Label for="robot_name">Robot Name</Label>
                            <Input
                                onChange={(e)=>{
                                this.onFieldChange(e, 'robot_name');
                                }}
                                type="text"
                                value={this.state.formFields['robot_name'].value}
                                name="robot_name"
                                id="robot_name"
                                placeholder="Enter the name"
                            />
                        </Col>
                        <Col ms="4">
                            <Label for="robot_model">Model Info</Label>
                            <Input
                                onChange={(e)=>{
                                    this.onFieldChange(e, 'robot_model');
                                }}
                               type="text"
                                value={this.state.formFields['robot_model'].value}
                                name="robot_model"
                                id="robot_model"
                                placeholder="Enter the model"
                            />
                        </Col>                         
                        <Col sm="4">
                            <Label for="robot_price">Price</Label>
                            <Input
                                onChange={(e)=>{
                                    this.onFieldChange(e, 'robot_price');
                                }}
                                type="number"
                                value={this.state.formFields['robot_price'].value}
                                name="robot_price"
                                id="robot_price"
                                placeholder="Enter the price"
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label for="manufacturer_id">Select Manufacturer</Label>
                            <Input
                                onChange={(e)=>{
                                    this.onFieldChange(e, 'robot_manu_id');
                                }}
                                type="select"
                                value={this.state.formFields['robot_manu_id'].value}
                                name="manufacturer_id"
                                id="manufacturer_id"
                            >
                                <option>Select One</option>
                                {this.getManufacturers()}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label for="robot_details">Details</Label>
                            <Input
                                onChange={(e)=>{
                                    this.onFieldChange(e, 'robot_details');
                                }}
                                type="textarea"
                                value={this.state.formFields['robot_details'].value}
                                name="robot_details"
                                id="robot_details"
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm="6">
                        <Uploader filename={this.setImageFileName} />
                            {
                                this.state.fileURL ?
                                    <img style={{width:'150px', height:'150px'}} src={this.state.fileURL} alt="nothing"/>
                                : null
                            }
                            <small>{this.state.image_name}</small>
                        </Col>
                        <Col sm="6">
                            {
                                this.state.error_msg ?
                                    (
                                        <Alert color="danger">
                                            {this.state.error_msg}
                                        </Alert>
                                    )
                                : null
                            }
                            <Button type="submit">Save</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default withRouter(AddRobot);


// WEBPACK FOOTER //
// ./src/components/dashboard/addrobot.js